'use client';

import { MapType, PowerBIEmbedProps } from '@/lib/power-bi/types';
import dynamic from 'next/dynamic';

interface PowerBIEmbedPropsExtended extends PowerBIEmbedProps {
  onReportReady?: (report: any, utils?: { navigateToPage: (type: MapType) => Promise<boolean> }) => void;
  forcedLocale?: string | null;
}

const PowerBIClientComponent = dynamic(
  () => import('./PowerBIClientComponent'),
  { 
    ssr: false,
    loading: () => (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-gray-300 border-t-blue-600 mb-2"></div>
          <p>Carregando dashboard...</p>
        </div>
      </div>
    )
  }
);

export default function PowerBIDashboard(props: PowerBIEmbedPropsExtended) {
  return <PowerBIClientComponent {...props} />;
}